package com.milta.core.localization.translations.nl

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Foto",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "net verzonden",
    fileWaitingConnectionLabel = "wacht op verbinding",
    analysingTitle = "Document lezen…",
    analysingSubtitle = "Het extraheren van de leveringen kan enkele seconden duren.",
    analysingSubtitlePdf = "Claude Haiku extraheert de leveringen — dit kan enkele seconden duren bij een gescande PDF.",
    stepFileSent = "Bestand verzonden",
    stepExtracting = "Velden extraheren",
    stepReview = "Controleren voor toevoegen",
    successTitle = "Levering gedetecteerd",
    successSubtitle = "Controleer de gegevens voordat u ze aan de rit toevoegt.",
    addToRouteButton = "Toevoegen aan de rit",
    scanAnotherButton = "Nog een document scannen",
    partialTitle = "Bijna volledig",
    partialSubtitle = "Een veld kon niet worden gelezen op het document.",
    missingFieldPlaceholder = "Aan te vullen…",
    partialBannerText = "Bepaalde gegevens konden niet worden gelezen. U kunt zo bevestigen en ze later aanvullen, of een duidelijker document opnieuw insturen.",
    retryFileButton = "Ander bestand opnieuw insturen",
    validateAndContinueButton = "Bevestigen en doorgaan",
    attemptLabel = "Poging",
    errorTitleUnreadable = "Onleesbaar document",
    errorTitleMissingFields = "Gegevens niet gevonden",
    errorTitleNetworkError = "Probleem tijdens analyse",
    errorTitleGeneric = "Analyse mislukt",
    errorSubtitle = "We konden geen levering detecteren op dit bestand.",
    errorBannerSuffixUnreadable = "afbeelding te donker of tekst afgesneden. Neem een goed gekaderde, goed verlichte foto, of stuur een duidelijker bestand.",
    errorBannerSuffixMissingFields = "er werd geen bruikbare informatie gevonden. Controleer de inhoud van het bestand of stuur een ander bestand.",
    errorBannerSuffixNetworkError = "de analysedienst ondervond een netwerkprobleem. Probeer het over enkele ogenblikken opnieuw.",
    errorBannerSuffixGeneric = "er is een onverwachte fout opgetreden tijdens de analyse. Probeer opnieuw of stuur een ander bestand.",
    retryWithNewFileButton = "Opnieuw proberen met een ander bestand",
    manualEntryButton = "Handmatig invoeren",
    attemptsRemainingNote = "U heeft nog 1 poging voor dit document.",
    maxAttemptsTitle = "Nog steeds onleesbaar",
    maxAttemptsSubtitle = "Dit document kon na 2 pogingen niet worden gelezen.",
    maxAttemptsBanner = "Maximaal aantal pogingen bereikt voor dit document. Vul de levering handmatig aan, of start de import opnieuw met een nieuw document.",
    retryUnavailableButton = "Opnieuw proberen — niet beschikbaar",
    newDocumentButton = "Nieuw document importeren",
    serviceUnavailableTitle = "Dienst tijdelijk niet beschikbaar",
    serviceUnavailableSubtitle = "De automatische analyse reageert momenteel niet.",
    serviceUnavailableBanner = "Probeer het over enkele ogenblikken opnieuw, of vul de levering ondertussen handmatig aan.",
    offlineTitle = "U bent offline",
    offlineSubtitle = "Uw bestand is klaar maar nog niet verzonden.",
    offlineBanner = "Maak opnieuw verbinding met internet en start de analyse opnieuw. Er is niets naar de server verzonden — er werd geen poging geteld.",
    retryOfflineButton = "Opnieuw proberen — geen verbinding",
    unsupportedFormatBanner = "Bestandsformaat niet ondersteund. Kies een foto, een PDF of een Excel/CSV-bestand.",
    validationTitle = "Leveringen controleren",
    fileRejectedTitle = "Bestand niet verzonden",
    fileRejectedSubtitle = "Kies een ander bestand om door te gaan.",
    bannerFileRequired = "er is geen bestand geselecteerd. Kies een PDF-bestand om door te gaan.",
    bannerInvalidPdfFormat = "niet-ondersteund formaat. Hier worden alleen PDF-bestanden geaccepteerd.",
    bannerFileTooLarge = "bestand te groot. Kies een lichter PDF-bestand.",
    chooseAnotherFileButton = "Kies een ander bestand",
)
